import {
  ConversationAssigneeSummary,
  ConversationResolutionSentiment,
} from "@redotech/redo-model/conversation-insights";

/**
 * Human-readable labels for conversation resolution sentiment.
 */
export const ConversationResolutionSentimentLabels: Record<
  ConversationResolutionSentiment,
  string
> = {
  [ConversationResolutionSentiment.POSITIVE]: "Positive",
  [ConversationResolutionSentiment.NEUTRAL]: "Neutral",
  [ConversationResolutionSentiment.NEGATIVE]: "Negative",
};

/**
 * Badge color mapping for conversation resolution sentiment.
 */
export const ConversationResolutionSentimentColorMap: Record<
  ConversationResolutionSentiment,
  "success" | "gray" | "error"
> = {
  [ConversationResolutionSentiment.POSITIVE]: "success",
  [ConversationResolutionSentiment.NEUTRAL]: "gray",
  [ConversationResolutionSentiment.NEGATIVE]: "error",
};

/**
 * Human-readable labels for conversation assignee summary.
 */
export const ConversationAssigneeSummaryLabels: Record<
  ConversationAssigneeSummary,
  string
> = {
  [ConversationAssigneeSummary.AI_AGENT_HANDLED]: "AI handled",
  [ConversationAssigneeSummary.MERCHANT_HANDLED]: "Merchant handled",
  [ConversationAssigneeSummary.AI_AGENT_HANDOFF_TO_HUMAN]:
    "AI handoff to human",
  [ConversationAssigneeSummary.AI_AGENT_HANDOFF_TO_IGNORED]:
    "AI handoff to ignored",
  [ConversationAssigneeSummary.MERCHANT_IGNORED]: "Merchant ignored",
};

/**
 * Badge color mapping for conversation assignee summary.
 */
export const ConversationAssigneeSummaryColorMap: Record<
  ConversationAssigneeSummary,
  "success" | "blue" | "warning" | "gray"
> = {
  [ConversationAssigneeSummary.AI_AGENT_HANDLED]: "success",
  [ConversationAssigneeSummary.MERCHANT_HANDLED]: "blue",
  [ConversationAssigneeSummary.AI_AGENT_HANDOFF_TO_HUMAN]: "warning",
  [ConversationAssigneeSummary.AI_AGENT_HANDOFF_TO_IGNORED]: "gray",
  [ConversationAssigneeSummary.MERCHANT_IGNORED]: "gray",
};
